/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/no-unnamed-components */

'use es6';

import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import ChecklistRow from '../ChecklistRow';
import GradeTypeConstants from '../../constants/GradeTypeConstants';
import MobileData from '../../data/MobileData';
import PerformanceData from '../../data/PerformanceData';
import SecurityData from '../../data/SecurityData';
import SeoData from '../../data/SeoData';
import get from 'hs-lodash/get';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ChecklistRows = ({
  websiteGrade,
  resultsData
}) => {
  const getGrade = result => {
    return get(websiteGrade, result.resultKeyPath);
  };
  const rows = resultsData.reduce((list, result, index) => {
    result.init(getGrade(result));
    if (result.gradeType === GradeTypeConstants.OK || result.gradeType === GradeTypeConstants.BAD) {
      list.push( /*#__PURE__*/_jsx(ChecklistRow, {
        result: result
      }, index));
    }
    return list;
  }, []);
  return rows;
};
const ChecklistTable = ({
  websiteGrade,
  resultsData,
  title
}) => {
  if (websiteGrade.overallGrade === 100) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    style: {
      paddingBottom: '10px'
    },
    children: /*#__PURE__*/_jsxs("table", {
      children: [/*#__PURE__*/_jsxs("colgroup", {
        children: [/*#__PURE__*/_jsx("col", {
          style: {
            width: '240px'
          }
        }), /*#__PURE__*/_jsx("col", {
          span: "2",
          style: {
            width: '120px'
          }
        })]
      }), /*#__PURE__*/_jsx("thead", {
        children: /*#__PURE__*/_jsxs("tr", {
          children: [/*#__PURE__*/_jsx("th", {
            children: title
          }), /*#__PURE__*/_jsx("th", {
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "results.checklist.headers.current"
            })
          }), /*#__PURE__*/_jsx("th", {
            colSpan: "2",
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "results.checklist.headers.recommendation"
            })
          })]
        })
      }), /*#__PURE__*/_jsx("tbody", {
        children: /*#__PURE__*/_jsx(ChecklistRows, {
          websiteGrade: websiteGrade,
          resultsData: resultsData
        })
      })]
    })
  });
};
export default (({
  websiteGrade
}) => {
  if (websiteGrade.overallGrade === 100) {
    return null;
  }
  const showSEO = websiteGrade.seoAudit && websiteGrade.seoAudit.grade !== 30;
  const showSecurity = websiteGrade.securityAudit && websiteGrade.securityAudit.grade !== 10;
  const showPerformance = websiteGrade.performanceAudit && websiteGrade.performanceAudit.grade !== 30;
  const showMobile = websiteGrade.mobileAudit && websiteGrade.mobileAudit.grade !== 30;
  return /*#__PURE__*/_jsx("div", {
    className: "checklist-page",
    children: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsxs("div", {
        className: "wsg-container",
        children: [/*#__PURE__*/_jsx("h3", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "results.checklist.title"
          })
        }), showPerformance && /*#__PURE__*/_jsx(ChecklistTable, {
          websiteGrade: websiteGrade,
          resultsData: PerformanceData.topResults.concat(PerformanceData.middleResults, PerformanceData.bottomResults),
          title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "results.performance.title"
          })
        }), showSEO && /*#__PURE__*/_jsx(ChecklistTable, {
          websiteGrade: websiteGrade,
          resultsData: SeoData.results,
          title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "results.seo.title"
          })
        }), showMobile && /*#__PURE__*/_jsx(ChecklistTable, {
          websiteGrade: websiteGrade,
          resultsData: MobileData.results,
          title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "results.mobile.title"
          })
        }), showSecurity && /*#__PURE__*/_jsx(ChecklistTable, {
          websiteGrade: websiteGrade,
          resultsData: SecurityData.results,
          title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "results.security.title"
          })
        })]
      })
    })
  });
});